/* MAIN */
const attempt = (fn, fallback) => {
    try {
        return fn();
    }
    catch {
        return fallback;
    }
};
/* EXPORT */
export { attempt };
